import { createFileRoute, redirect } from "@tanstack/react-router";

/** Permanent redirect: the guide now lives at /resources/f1-visa-guide. */
export const Route = createFileRoute("/resources/fresher-guide")({
  head: () => ({
    meta: [
      { title: "Fresher Guide to US Visa Interviews - WeLivdIt" },
      {
        name: "description",
        content:
          "This fresher F-1 visa guide has moved to the WeLivdIt F-1 Visa Guide with 2026 interview rules, officer questions and DS-160 checks.",
      },
      { property: "og:title", content: "Fresher Guide to US Visa Interviews - WeLivdIt" },
      {
        property: "og:description",
        content: "Now part of the WeLivdIt F-1 Visa Guide: 2026 interview rules, officer questions and DS-160 checks.",
      },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://welivdit.com/resources/f1-visa-guide" }],
  }),
  beforeLoad: () => {
    throw redirect({ to: "/resources/f1-visa-guide", statusCode: 301 });
  },
  component: () => null,
});
